import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { storage, authFB } from '../../helpers/Firebase';
import { servicePath, storagePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import moment from 'moment';
import { 
  AWARD_DETAIL_LIST,
  AWARD_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT,
  AWARD_DETAIL_ADD,
  AWARD_DETAIL_DETAIL,
  AWARD_DETAIL_UPDATE,
  AWARD_DETAIL_UPLOAD_SET
} from '../actions';
import {
  AwardDetailListSuccess,
  AwardDetailListError,
  AwardDetailSearchDeliveryOrderLineLotSuccess,
  AwardDetailSearchDeliveryOrderLineLotError,
  AwardDetailAddSuccess,
  AwardDetailAddError,
  AwardDetailDetailSuccess,
  AwardDetailDetailError,
  AwardDetailUpdateSuccess,
  AwardDetailUpdateError,
  AwardDetailUploadSetSuccess,
  AwardDetailUploadSetError
} from '../actions';
 
export function* watchAwardDetailList() {
  yield takeEvery(AWARD_DETAIL_LIST, onAwardDetailList);
}

export function* watchAwardDetailSearchDeliveryOrderLineLot() {
  yield takeEvery(AWARD_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT, onAwardDetailSearchDeliveryOrderLineLot);
}

export function* watchAwardDetailAdd() {
  yield takeEvery(AWARD_DETAIL_ADD, onAwardDetailAdd);
}

export function* watchAwardDetailDetail() {
  yield takeEvery(AWARD_DETAIL_DETAIL, onAwardDetailDetail);
}

export function* watchAwardDetailUpdate() {
  yield takeEvery(AWARD_DETAIL_UPDATE, onAwardDetailUpdate);
}

export function* watchAwardDetailUpload() {
  yield takeEvery(AWARD_DETAIL_UPLOAD_SET, onAwardDetailUpload);
}

const onAwardDetailListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'award_detail/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onAwardDetailUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'award_detail/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onAwardDetailSearchDeliveryOrderLineLotAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_order_line_lot', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onAwardDetailAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'award_detail/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onAwardDetailDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'award_detail/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onAwardDetailUploadAsync = async (file) => {
  var user = await authFB.currentUser;
  var storageRef = storage.ref()
  let now = moment();
  let filename = `${now.format("x")}.${file.name.substr(file.name.lastIndexOf('.') + 1)}`;
  return await new Promise((success, reject) => {
    var uploadTask = storageRef.child(storagePath+'/award_detail/' + filename).put(file);
    uploadTask.on('state_changed',
    function(snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
    }, 
    function(error) {
      reject({ name: filename, original: file.name, message: error.code, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid+'/consult_award_details/' })
    }, 
    function() {
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) { 
          success({ message: 'success', name: filename, original: file.name, url: downloadURL, type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid +'/consult_award_details/'});
      });
    });
  });
};


function* onAwardDetailList(data) {
  try {
    const response = yield call(onAwardDetailListAsync, data.payload);
    yield put(AwardDetailListSuccess(response.data));
  } catch (error) {
    yield put(AwardDetailListError(error));
  }
}

function* onAwardDetailSearchDeliveryOrderLineLot(data) {
  try {
    const response = yield call(onAwardDetailSearchDeliveryOrderLineLotAsync, data.payload);
    yield put(AwardDetailSearchDeliveryOrderLineLotSuccess(response.data));
  } catch (error) {
    yield put(AwardDetailSearchDeliveryOrderLineLotError(error));
  }
}

function* onAwardDetailAdd(data) {
  try {
      const response = yield call(onAwardDetailAddAsync, data);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(AwardDetailAddSuccess(response.data));
  } catch (error) {
      yield put(AwardDetailAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onAwardDetailDetail(data) {
  try {
    const response = yield call(onAwardDetailDetailAsync, data.payload);
    yield put(AwardDetailDetailSuccess(response.data, data.payload.id_award_detail));
  } catch (error) {
    yield put(AwardDetailDetailError(error, data.payload.id_award_detail));
  }
}

function* onAwardDetailUpdate(data) {
  try {
      const response = yield call(onAwardDetailUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(AwardDetailUpdateSuccess(response.data));
  } catch (error) {
      yield put(AwardDetailUpdateError(error));
  }
}

function* onAwardDetailUpload({ payload }) {
  const { file } = payload;
  try {
    const response = yield call(onAwardDetailUploadAsync, file);
    if(response.message ==='success'){
      yield put(AwardDetailUploadSetSuccess(response));
    }
    else{
      yield put(AwardDetailUploadSetError(response));
    }
  } catch (error) {
    yield put(AwardDetailUploadSetError({ name: '', original: file.name, message: error, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path:''}))
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchAwardDetailList),
    fork(watchAwardDetailSearchDeliveryOrderLineLot),
    fork(watchAwardDetailAdd),
    fork(watchAwardDetailDetail),
    fork(watchAwardDetailUpdate),
    fork(watchAwardDetailUpload),
  ]);
} 